import PerformanceFrequency from './PerformanceFrequency';
import './Table/index.scss';

export default PerformanceFrequency;